import React from "react";
import VsPage from "./VsPage";

export default function VsStockAlarm() {
  return (
    <VsPage
      slug="stock-alarm"
      competitor="Stock Alarm"
      competitorPrice="~$9.99/mo"
      tagline="Stock Alarm is a mobile-first custom-price-alert app with 300k+ traders and a 4.8 App Store rating. Moonbucks is a curated, analyst-vetted alert service with a public track record. Different jobs. Here's when each one is right."
      rows={[
        { label: "Price alerts on tickers you already know",             them: true, us: "Not the core product" },
        { label: "Curated buy-alert shortlist (analyst-picked names)",   them: false, us: true },
        { label: "Every alert human-reviewed before publishing",         them: false, us: true },
        { label: "Public track record — every trade, every outcome",     them: false, us: true },
        { label: "$10K portfolio simulation with disclosed rules",       them: false, us: true },
        { label: "Discord subscriber channel",                            them: false, us: true },
        { label: "Push + email delivery",                                 them: true, us: true },
      ]}
      whenThem={[
        "You already have a watchlist and just want price/volume triggers on it.",
        "You want a mobile-first, App-Store-rated tool with years of reviews.",
        "You don't want anyone picking tickers for you.",
      ]}
      whenUs={[
        "You want the desk to hand you the shortlist — not build your own.",
        "You want to see every trade's outcome before you subscribe.",
        "You want a plain-English paragraph, not a raw price ping.",
      ]}
    />
  );
}
